// Module
var code = "<span v-bind:class=\"allClasses\"> <template v-for=\"n in 3\"> <i v-bind:class=\"getStarClass(n)\" @click=\"starClickHandle(n)\" v-if=\"checkStarShouldBeRendered(n)\"></i> </template> {{priorityName}} </span>";
// Exports
module.exports = code;